import styled from 'styled-components'

const BUTTON_SIZE = 35

export const ButtonContainer = styled.button`
  position: relative;
  width: ${BUTTON_SIZE}px;
  height: ${BUTTON_SIZE}px;

  transition: all 0.2s ease-in-out;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0;

  &:hover,
  &:focus-visible {
    background: rgba(0, 0, 0, 0.1);
  }

  svg {
    stroke: ${props => props.theme.colors.color005597};
    width: ${BUTTON_SIZE}px;
    height: ${BUTTON_SIZE}px;
  }
`
